import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PaintRoller.svg",
  "use": "PaintRoller.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"PaintRoller.svg\"><path d=\"M51.4183,33.8158,37.2816,36.1712a3.8915,3.8915,0,0,0-3.2608,3.85,2,2,0,0,1,2,2v12a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-12a2,2,0,0,1,2-2,7.8773,7.8773,0,0,1,6.603-7.7949L50.76,29.87a3.8909,3.8909,0,0,0,3.2607-3.85,3.0034,3.0034,0,0,0-3-3v1a4,4,0,0,1-4,4h-30a4,4,0,0,1-4-4v-6a4,4,0,0,1,4-4h30a4,4,0,0,1,4,4v1a7.0081,7.0081,0,0,1,7,7A7.8776,7.8776,0,0,1,51.4183,33.8158Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol